// FeaturedContainer.js
import { useContext, useState } from "react";

import NoteActions from "@/components/NoteActions";
import SongCard from "@/components/SongCard";
import { SubscribedContext } from "@/providers/Subscribed";
import { Box, Button, Card, CardMedia, Stack, Typography } from "@mui/material";
import { ShoppingCart } from "@mui/icons-material";
import ReactPlayer from "react-player";
import ActiveContentDrawer from "@/components/ActiveContentDrawer";

export default function FeaturedImageVideo({ content }) {
  const { isSubscribed, handleModalOpen } = useContext(SubscribedContext);
  const [open, setOpen] = useState(false);

  const handleClickVideo = (e) => {
    if (!isSubscribed) {
      e.preventDefault();
      handleModalOpen();
      return;
    }
  };

  if (content.type == "merch") {
    return (
      <Box>
        <Card
          style={{
            borderRadius: "20px",
            position: "relative",
            height: "300px",
            width: "300px",
          }}
          onClick={() => setOpen(true)}
        >
          <CardMedia
            component="img"
            src={content.meta.cover}
            style={{ borderRadius: "10px", height: "300px", width: "300px" }}
          />
          <Box
            style={{
              position: "absolute",
              bottom: 10,
              right: 10,
              margin: "8px",
              opacity: 0.8,
              color: "#04FFFF",
            }}
          >
            <ShoppingCart style={{ fontSize: "30px" }} />
          </Box>
        </Card>
        <NoteActions content={content} />
        <ActiveContentDrawer content={content} open={open} setOpen={setOpen} />
      </Box>
    );
  }

  return (
    <Box>
      <Box>
        {content.type == "audio" && <SongCard content={content} />}

        {content.type == "image" && (
          <Box style={{ overflow: "hidden", borderRadius: "10px" }}>
            <CardMedia
              component="img"
              image={content.meta.url}
              sx={{
                borderRadius: 3,
                height: "300px",
                width: "300px",
                aspectRatio: "1/1",
              }}
            />
          </Box>
        )}

        {content.type == "video" && (
          <Card
            style={{ borderRadius: "15px" }}
            onClick={(e) => handleClickVideo(e)}
          >
            <ReactPlayer
              url={content.meta.url}
              light={content.meta.cover}
              playing={true}
              controls={true}
              height="300px"
              width="300px"
            />
          </Card>
        )}

        {content.type == "welcome" && (
          <Card style={{ borderRadius: "15px" }}>
            <ReactPlayer
              url={content.owner.meta.welcome}
              light={content.owner.meta.cover}
              playing={true}
              controls={true}
              height="300px"
              width="300px"
            />
          </Card>
        )}
      </Box>

      <NoteActions content={content} />
    </Box>
  );
}
